import { render, staticRenderFns } from "./BondedSelling.vue?vue&type=template&id=2537bb65&"
import script from "./BondedSelling.vue?vue&type=script&lang=js&"
export * from "./BondedSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports